// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"662ed510","952":"69b69471"}[chunkId] + ".chunk.js";
};